const _errs = Symbol();
const _firmName = Symbol();
const _address = Symbol();
const _contactNo = Symbol();
const _maxLimit = Symbol();
const _creditorId = Symbol();
const _proprietorName = Symbol();
const _email = Symbol();
const _panNumber = Symbol();
const _shortName = Symbol();
const _hasSmallCreditor = Symbol();
const _disabled = Symbol();
class Creditor {
    constructor({ firmName, proprietorName, email, panNumber, address, contactNo, maxLimit, creditorId, shortName, hasSmallCreditor, disabled = false }) {

        this[_errs] = {};

        Object.defineProperties(this, {
            firmName: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 45) {
                        this[_firmName] = value.toUpperCase();
                        delete this[_errs].firmName;
                    } else {
                        this[_errs].firmName = "firm name  must be between 2 to 45 characters";
                    }
                },

                get: function () {
                    return this[_firmName];
                }
            },
            shortName: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 50) {
                        this[_shortName] = value.toUpperCase();
                        delete this[_errs].shortName;
                    } else {
                        this[_errs].shortName = "Short name  must be between 2 to 50 characters";
                    }
                },

                get: function () {
                    return this[_shortName];
                }
            },


            proprietorName: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 45) {
                        this[_proprietorName] = value.toUpperCase();
                        delete this[_errs].proprietorName;
                    } else {
                        this[_errs].proprietorName = "proprietorName  must be between 2 to 45 characters";
                    }
                },
                get: function () {
                    return this[_proprietorName];
                }
            },
            email: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    var re = /\S+@\S+\.\S+/;
                    // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    var success = re.test(value);
                    if (success && value.length < 45) {
                        this[_email] = value;
                        delete this[_errs].email;
                    } else {
                        this[_errs].email = "Must be a valid email within 45 character";
                    }
                },
                get: function () {
                    return this[_email];
                }
            },


            address: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 70) {
                        this[_address] = value.toUpperCase();
                        delete this[_errs].address;
                    } else {
                        this[_errs].address = "address must be between 2 to 70 characters";
                    }
                },
                get: function () {
                    return this[_address];
                }
            },
            contactNo: {
                enumerable: true,
                configurable: true,
                set: function (value) {

                    if (typeof value === "string" && value.length >= 10 && value.length <= 20) {
                        this[_contactNo] = value;
                        delete this[_errs].contactNo;
                    } else {
                        // this[_errs].contactNo = "Contact number must be between 10 to 20 characters";

                        // makeing contact no optional
                    }



                },
                get: function () {
                    return this[_contactNo];
                }
            },
            panNumber: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    // pan number length not checked bcoz lack of time
                    this[_panNumber] = value || null;
                },
                get: function () {
                    return this[_panNumber];
                }
            },
            maxLimit: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseInt(value, 10);
                    if (x) {
                        this[_maxLimit] = x;
                        delete this[_errs].maxLimit;
                    } else {
                        this[_errs].maxLimit = "maximum limit amount  must be a valid integer";
                    }

                },
                get: function () {
                    return this[_maxLimit];
                }
            },
            creditorId: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    this[_creditorId] = value;
                },
                get: function () {
                    return this[_creditorId];
                }
            },
            hasSmallCreditor: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    this[_hasSmallCreditor] = value;
                },
                get: function () {
                    return this[_hasSmallCreditor];
                }
            },
            disabled: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    this[_disabled] = value;
                },
                get: function () {
                    return this[_disabled];
                }
            }
        });
        this.hasSmallCreditor = hasSmallCreditor;
        this.firmName = firmName;
        this.shortName = shortName;
        this.proprietorName = proprietorName;
        this.email = email;
        this.panNumber = panNumber;
        this.address = address;
        this.contactNo = contactNo;
        this.maxLimit = maxLimit;
        this.creditorId = creditorId;
        this.disabled = disabled;
    }

    hasError() {
        return Object.keys(this[_errs]).length > 0;
    }

    getErrors() {
        return this[_errs];
    }

}

module.exports = Creditor;


// WEBPACK FOOTER //
// ./src/models/creditor.js